import { v2Client } from '@api/apiClient'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

type UploadFilesData = {
  formData: FormData
  onSuccess?: (res: AxiosResponse<any>) => void
  onError?: () => void
  onUploadProgress?: (progress: { loaded: number; total: number; progress: number }) => void
  href: string
}

export const usePostUploadFiles = () => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: ({ formData, href, onUploadProgress }: UploadFilesData) =>
      v2Client.post(href ?? '/files/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) =>
          onUploadProgress
            ? onUploadProgress({
                loaded: e.loaded,
                total: e.total ?? 0,
                progress: e.progress ? e.progress : e.total ? Math.round((e.loaded * 100) / e.total) : 0,
              })
            : undefined,
      }),
    onSuccess: (data, variables) => {
      variables?.onSuccess?.(data)
      enqueueSnackbar(t('index.documents.upload_files_success'), { variant: 'success' })
    },
    onError: (error, variables) => {
      variables?.onError?.()
      enqueueSnackbar(t('index.documents.upload_files_error'), { variant: 'error' })
    },
  })
}
